module.exports = __webpack_public_path__ + "img/3-2.5df63390.png";